import { all } from "redux-saga/effects";

import authSaga from "./auth/saga";
import getOrganizationAndRestaurantSaga from "./getOrganizationAndRestaurant/saga";
import usersSaga from "./users/saga";
import organizationsSaga from "./organizations/saga";
import qrSaga from "./qr/saga";
import discountSaga from "./discounts/saga";
import salesInfoSaga from "./salesInfo/saga";
import dashboardSaga from "./dashboard/saga";
import organizationsStatistics from "./organizationsStatistics/saga";
import tablesInfoSaga from "./tablesInfo/saga";
import menuConfigurationSaga from "./menuConfiguration/saga";
import waitersSaga from "./waiters/saga";
import logsHistorySaga from "./logsHistory/saga";
import areasSaga from "./areas/saga";
import driversSaga from "./drivers/saga";
import reportsStatisticsSaga from "./reportsStatistics/saga";
import restaurantSchemaSaga from "./restaurantSchema/saga";
import reservationsSaga from "./reservations/saga";
import reservationHistorySaga from "./reservationHistory/saga";
import myMenuOrders from "./myMenuOrders/saga";
import ordersExecutionSaga from "./ordersExecution/saga";
import usersReportsSaga from "./usersReports/saga";
import myMenuSurveySaga from "./myMenuSurvey/saga";
import tablesEfficiencySaga from "./tablesEfficiency/saga";
import invoicesSaga from "./invoices/saga";
import productProfitabilitySaga from "./productProfitability/saga";

export default function* rootSaga(getState) {
  yield all([
    authSaga(),
    getOrganizationAndRestaurantSaga(),
    usersSaga(),
    organizationsSaga(),
    qrSaga(),
    discountSaga(),
    salesInfoSaga(),
    dashboardSaga(),
    organizationsStatistics(),
    tablesInfoSaga(),
    menuConfigurationSaga(),
    waitersSaga(),
    logsHistorySaga(),
    areasSaga(),
    driversSaga(),
    reportsStatisticsSaga(),
    restaurantSchemaSaga(),
    reservationsSaga(),
    reservationHistorySaga(),
    myMenuOrders(),
    ordersExecutionSaga(),
    usersReportsSaga(),
    myMenuSurveySaga(),
    tablesEfficiencySaga(),
    invoicesSaga(),
    productProfitabilitySaga(),
  ]);
}
